module.exports = __webpack_public_path__ + "static/media/Blank-Home_Purple.b3915486.png";